import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {NzModalService, NzMessageService} from 'ng-zorro-antd';
import {takeUntil, take} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {ShopsService, RootService} from 'src/app/services';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {ActivatedRoute, Router} from '@angular/router';
import {removeEmptyQuery, sleep} from 'src/app/helpers';
import {Location} from '@angular/common';

@Component({
  selector: 'app-shop-detail',
  templateUrl: './shop-detail.component.html',
  styleUrls: ['./shop-detail.component.scss']
})
export class ShopDetailComponent implements OnInit, OnDestroy {

  constructor(
    private shopService: ShopsService,
    private notification: NzNotificationService,
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private location: Location,
  ) {
  }

  unsubscribe$ = new Subject<void>();

  page = 1;
  pageSize = 10;
  phoneNumber = ''
  shopName = ''
  // ================================list==================================//
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  total: number;
  loading = true;
  listOfDisplayData: any[] = [];
  listOfAllData: any[] = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  ids: any[] = [];
  isShow;
  role: string;
  isOwner = 2;
  data = []
  // ============================search=============================//
  keyword: string;
  title_code: number;
  titles: any[];

  delayTimer: any;

  shopId: string;

  /*Check link image error*/
  imageFalse: any[] = [];

  dataDelete = {
    label: 'Xác nhận xóa điểm bán',
    value: '<p>Bạn có chắc chắn muốn xoá điểm bán?</p>'
  };

  // Cập nhật tiêu đề và xác thực
  dataVerify = {
    label: 'Bỏ xác thực điểm bán',
    value: '<p>Bạn có chắc chắn muốn bỏ xác thực điểm bán?</p>'
  };

  dataBlock = {
    label: 'Bỏ chặn điểm bán',
    value: '<p>Bạn có chắc chắn muốn bỏ chặn điểm bán?</p>'
  };

  // ===============================actions=================================//
  @ViewChild('addStores', {static: true}) addStores;
  @ViewChild('deleteStores', {static: true}) deleteStores;
  @ViewChild('verifyStores', {static: true}) verifyStores;
  @ViewChild('unVerifyStores', {static: true}) unVerifyStores;
  @ViewChild('blockStores', {static: true}) blockStores;
  @ViewChild('unBlockStores', {static: true}) unBlockStores;

  action: any;

  openMessage(type: string, title: string, content: any) {
    return this.notification.create(
      type,
      title,
      content
    );
  }

  currentPageDataChange($event: any[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(data?): void {
    console.log(data)
    if (data) {
      const index = this.data.findIndex(z => z.id === data.id);
      index === -1 ? this.data.push({phoneNumber: data.phoneNumber, shopName: data.shopName, productId: data.id,  barcode: data.barcode, title: data.title}) : this.data.splice(index, 1);

    }
    this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item.id]);
    this.isIndeterminate = this.listOfDisplayData.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    this.ids = [];
    for (const [key, value] of Object.entries(this.mapOfCheckedId)) {
      if (value) {
        this.ids.push(key);
      }
    }
    if (this.ids.length > 0) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(item => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
  }

  clearPosParam() {
    // @ts-ignore
    this.location.replaceState(this.location.path().split('?')[0], '');
  }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(params => {
      // console.log(1111, params);
      if (params.barcode !== undefined) {
        this.clearPosParam();
        this.keyword = params.barcode;
        this.isOwner = params.isOwner;
      }
      this.loadData( );

    });

    if (this.isOwner == 2) {
      this.shopService.currentShopType.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        if (data === 'default') {
          this.route.navigate([`business/shops`]);
          return;
        }
        if (data.shop_type === 'online' || (data.shop_type === 'offline' && data.is_owner == 0)) {
          this.role = 'more';
          return;
        }
        if (data.is_owner == 1) {
          this.role = 'full';
          return;
        }
      });
    } else {
      this.shopService.currentShopType.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        // @ts-ignore
        if (this.isOwner == 0) {
          this.role = 'more';
          return;
        }
        // @ts-ignore
        if (this.isOwner == 1) {
          this.role = 'full';
          return;
        }
      });
    }

    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.loadTitle();
    this.loadData();
  }

  search() {
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      this.page = 1;
      this.loadData();
    }, 300);
  }

  filterTitle($event: number) {
    this.title_code = $event;
    this.page = 1;
    this.loadData();
  }

  loadTitle() {
    this.shopService.getAllTitle().pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res: any) => {
        this.titles = res.data.items;
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        return;
      },
    );
  }

  loadData(ms = 0) {

    this.activatedRoute.params.subscribe(async param => {
      console.log(param)
      if (param.id) {
        this.shopId = param.id;
        this.phoneNumber = param.phoneNumber;
        this.shopName = param.shopName;
        const query: any = {
          keyword: this.keyword ? this.keyword.trim() : null,
          title_code: this.title_code,
          page: this.page,
          page_size: this.pageSize,
        };

        removeEmptyQuery(query);
        await sleep(ms);

        this.loading = true;
        this.shopService.getAllProductByStore(param.id, query).pipe(takeUntil(this.unsubscribe$)).subscribe(
          (res) => {
            this.loading = false;
            this.total = res.data.totalElement;
            this.listOfAllData = res.data.items.map(z => {
              return {...z , phoneNumber: this.phoneNumber, shopName: this.shopName}
            });
            if (!res.data.items && this.page > 1) {
              this.page = this.page - 1;
              this.loadData();
              return;
            }
          },
          (err) => {
            this.notification.create(
              'error',
              'Có lỗi xảy ra !!!',
              `${err}`
            );
          }
        );
      }
    });
  }

  resetData() {
    this.keyword = null;
    this.title_code = null;
    this.titles = null;
    this.page = 1;
    this.loadData();
  }

  checkImageErr(imageError: any) {
    this.imageFalse.push(imageError);
  }

  showImage(id: any, imageLink: any) {
    if (!this.imageFalse.includes(id)) {
      window.open(imageLink, '_blank');
    }
  }

  // ==============================output====================================//
  add(data: any) {
    const body: any = {
      type_id: data.type_id,
      product_ids: data.product_ids
    };
    this.shopService.add(this.shopId, body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        this.addStores.success();
        if (res.code === 1) {
          this.openMessage('success', 'Thành công', 'Thêm sản phẩm thành công');
          this.addStores.handleCancel();
          this.loadData(500);
          return;
        }
        if (res.code !== 1) {
          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          return;
        }
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.addStores.success();
        return;
      },
    );
  }

  delete(id: any) {
    const body = {
      body: {
        product_ids: id,
      },
    };


    this.shopService.destroyProductByStore(this.shopId, body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        if (res.code === 1) {


          this.mapOfCheckedId = {};
          this.openMessage('success', 'Thành công', 'Xóa sản phẩm thành công');
          this.deleteStores.handleCancel();
          this.loadData(500);
        }
        if (res.code === 103) {


          this.openMessage('warning', 'Cảnh báo', `Doanh nghiệp không có quyền thực hiện tính năng này`);
          return;
        }
        if (res.code !== 1) {

          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
        }
        this.deleteStores.success();
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.deleteStores.success();
        return;
      },
    );
  }

  verify(data: any) {
    if (data.title) {
      const body: any = {
        type_id: data.body.type_id,
        product_ids: this.ids,
      };
      this.updateTitle(this.shopId, body);
    } else {
      const body: any = {
        type_id: data.type_id,
        product_ids: this.ids,
      };


      this.shopService.verify(this.shopId, body).pipe(takeUntil(this.unsubscribe$)).subscribe(
        (res) => {
          this.verifyStores.success();
          if (res.code === 1) {


            this.mapOfCheckedId = {};
            this.openMessage('success', 'Thành công', 'Xác thực sản phẩm thành công');
            this.verifyStores.handleCancel();
            this.loadData(500);
            return;
          }
          if (res.code !== 1) {


            this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            return;
          }
        },
        (err) => {

          this.openMessage('error', 'Lỗi !!!', `${err}`);
          this.verifyStores.success();
        },
      );
    }
  }

  updateTitle(shopId: string, body: any) {

    this.shopService.updateTitle(shopId, body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        this.verifyStores.success();
        if (res.code === 1) {

          this.mapOfCheckedId = {};
          this.openMessage('success', 'Thành công', 'Cập nhật tiêu đề sản phẩm thành công');
          this.verifyStores.handleCancel();
          this.loadData(500);
          return;
        }
        if (res.code !== 1) {


          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          return;
        }
      },
      (err) => {


        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.verifyStores.success();
        return;
      },
    );
  }

  unVerify(id: any) {
    const body = {
      body: {
        product_ids: id,
      },
    };

    this.shopService.unverify(this.shopId, body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        if (res.code === 1) {

          this.mapOfCheckedId = {};
          this.openMessage('success', 'Thành công', 'Hủy xác thực sản phẩm thành công');
          this.unVerifyStores.handleCancel();
          this.loadData(500);
        }
        if (res.code !== 1) {

          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
        }
        this.unVerifyStores.success();
      },
      (err) => {

        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.unVerifyStores.success();
        return;
      },
    );
  }

  block(data: any) {
    const body: any = {
      note: data.note,
      proof_images: data.proof_images,
      reason_id: data.reason_id,
      product_ids: this.ids,
    };



    this.shopService.block(this.shopId, body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {


        this.blockStores.success();
        if (res.code === 1) {
          this.mapOfCheckedId = {};
          this.openMessage('success', 'Thành công', 'Chặn sản phẩm thành công');
          this.blockStores.handleCancel();
          this.loadData(500);
          return;
        }
        if (res.code !== 1) {

          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          return;
        }
      },
      (err) => {

        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.blockStores.success();
        return;
      },
    );
  }

  unBlock(id: any) {
    const body = {
      body: {
        product_ids: id,
      },
    };

    this.shopService.unblock(this.shopId, body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res) => {
        if (res.code === 1) {


          this.mapOfCheckedId = {};
          this.openMessage('success', 'Thành công', 'Bỏ chặn sản phẩm thành công');
          this.unBlockStores.handleCancel();
          this.loadData(500);
        }
        if (res.code !== 1) {


          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
        }
        this.unBlockStores.success();
      },
      (err) => {

        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.unBlockStores.success();
        return;
      },
    );
  }

  actionsButton() {
    switch (this.action) {
      case '1' : this.addStores.showModal(); break;
      case '2' : this.verifyStores.showModal('updateTitleStore'); break;
      case '3' : this.verifyStores.showModal('verifyStore'); break;
      case '4' : this.unVerifyStores.showModal(this.dataVerify, this.ids); break;
      case '5' : this.blockStores.showModal(); break;
      case '6' : this.unBlockStores.showModal(this.dataBlock, this.ids); break;
      case '7' : this.deleteStores.showModal(this.dataDelete, this.ids); break;
    }
    this.action = null;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
